import { Component, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { Orgstyle } from '@src/app/helpers/dynamicstyle/model/orgstyle';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { Person } from '@src/app/models/person';
import { PersonOrganization } from '@src/app/models/personorganization';
import { Subscription } from 'rxjs';
import { TopNavService } from '../service/top-nav.service';
import { BrandService } from './service/brand.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.css']
})
export class BrandComponent implements OnInit {

  @Output() orgstyle:Orgstyle;
  orgId:string;
  dynStyleSubscription:Subscription;
  @Output() norgyet:boolean;
  @Output() et_admin:boolean;
  @Output() person:Person;
  @Output() orglist:PersonOrganization[];
  @Output() chosenOrg:PersonOrganization;
  orgnamelenght:number =200;
  @Output() imgtype:string;

  moduleWhitelabel:boolean;
  logoformat:string;

  constructor(
    private router: Router,
    private brandservice: BrandService,
    private uievent:UieventhubService,
    private authservice:AuthorizationService
    //private swPush: SwPush
  ) {
    this.dynStyleSubscription = this.uievent.dynamicStyle$.pipe(untilDestroyed(this)).subscribe(style => {
      //console.log('Dyn style subscription reached in brand',style);
      if(style && style.logoformat != "" && style.logoformat != undefined){
        this.orgstyle = style;
        this.logoformat = this.orgstyle.logoformat;

        //console.log('LOGO FORMAT FROM SUBSCRIPTION',this.logoformat);
        this.imgtype = this.orgstyle.logoformat == 'rectangel' ? 'rect' : 'square';
      }
      
    });
   }
   ngOnDestroy(): void {
    if (this.dynStyleSubscription) this.dynStyleSubscription.unsubscribe();

  }

  ngOnInit(): void {
    this.orglist = [];
    if(SessionHelper.getPerson()){
      this.person = JSON.parse(SessionHelper.getPerson()) ;
    this.et_admin = this.person.et_admin;
    }
    
    
    if(SessionHelper.getPersonOrgs()){
      Array.isArray(JSON.parse(SessionHelper.getPersonOrgs())) ?
       this.orglist = JSON.parse(SessionHelper.getPersonOrgs()) : 
      this.orglist.push( JSON.parse(SessionHelper.getPersonOrgs()));
      }
      function finddefaultOrg(org:PersonOrganization){
        return org.organizationId == SessionHelper.getChoosenOrg();
        
     }
      if(this.orglist.length>0 && Array.isArray(this.orglist)){
        this.norgyet = false;
        //if session has choosen org set it loacally
        if(SessionHelper.getChoosenOrg() != 'undefined' && SessionHelper.getChoosenOrg() != null){
          
          this.chosenOrg = this.orglist.find(finddefaultOrg);
        }else{
          //If no choosen org in session set it to the first element of the org list
            this.chosenOrg = this.orglist[0];
            SessionHelper.setChoosenOrg(this.orglist[0].organizationId);
            this.orgnamelenght = 100 + this.chosenOrg.organization.length * 10;

        }

      }
      this.moduleWhitelabel = Boolean(this.chosenOrg && this.chosenOrg.modules && this.chosenOrg.modules.indexOf('whitelabel') >= 0);
      this.orgId = SessionHelper.getChoosenOrg();
      const ds = SessionHelper.getDynamicStyle();
      this.orgstyle = ds && ds !== 'undefined' ? JSON.parse(ds) : null;
      if(this.orgstyle){
        this.logoformat = this.orgstyle.logoformat;
      //console.log('LOGO FORMAT FROM INIT',this.logoformat);
      this.imgtype = this.orgstyle.logoformat == 'rectangel' ? 'rect' : 'square';
      }
      
    
  }
  
  canEditOrg(){
    return this.authservice.isAuthorized('orgedit',SessionHelper.getChoosenOrg());
  }

  orgClicked(org:PersonOrganization){
    //console.log('BRAND ORG CHANGE',org);
   //this.norgyet = false;
   SessionHelper.setChoosenOrg(org.organizationId);
     //this.authservice.refreshPersonAuth(SessionHelper.getUserSub());
         this.router.navigateByUrl('/', {skipLocationChange: true})
             .then(()=>this.router.navigate(['/portal']));
    
    
   
  }
  noOrgYet(){
    return this.norgyet;
  }

  logoClicked(){
    
    if(!this.et_admin && this.orglist.length < 2 ){
      if(SessionHelper.getCustomer()){
        this.uievent.addLoader('portal');
        this.router.navigate(['/customerlight']);
      }else{
        this.uievent.addLoader('portal');
      this.router.navigate(['/portal']);
      }
    } else if(this.et_admin && SessionHelper.getViewAsCustomer() != 'true'){
      this.uievent.setShowOrgChooser(true);
    }
  }
}
